function upperCaseLocale(lang) {
  return lang
    .split("-")
    .join("_")
    .toUpperCase();
}

export function initHelpscoutBeacon(lang) {
  if (
    !process.env["VUE_APP_HELPSCOUT_KEY_" + upperCaseLocale(lang)] &&
    !process.env.VUE_APP_HELPSCOUT_KEY
  ) {
    return;
  }

  !(function(e, t, n) {
    function a() {
      var e = t.getElementsByTagName("head")[0],
        n = t.createElement("script");
      (n.type = "text/javascript"),
        (n.async = !0),
        (n.src = "https://beacon-v2.helpscout.net"),
        e.parentNode.insertBefore(n, e);
    }
    if (
      ((e.Beacon = n = function(t, n, a) {
        e.Beacon.readyQueue.push({ method: t, options: n, data: a });
      }),
      (n.readyQueue = []),
      "complete" === t.readyState)
    )
      return a();
    e.attachEvent
      ? e.attachEvent("onload", a)
      : e.addEventListener("load", a, !1);
  })(window, document, window.Beacon || function() {});

  window.Beacon(
    "init",
    process.env["VUE_APP_HELPSCOUT_KEY_" + upperCaseLocale(lang)] ??
      process.env.VUE_APP_HELPSCOUT_KEY
  );
}

export function refreshHelpscoutBeacon(newLang) {
  if (
    process.env["VUE_APP_HELPSCOUT_KEY_" + upperCaseLocale(newLang)] &&
    !process.env.VUE_APP_HELPSCOUT_KEY
  ) {
    return;
  }

  window.Beacon("destroy");
  window.requestAnimationFrame(() => {
    window.Beacon(
      "init",
      process.env["VUE_APP_HELPSCOUT_KEY_" + upperCaseLocale(newLang)] ??
        process.env.VUE_APP_HELPSCOUT_KEY
    );
  });
}
